<template>
  <div class="contact_index">
    <div class="contact_index_text">
      <p style="font-size: 22px;margin-bottom: 10px">关于我们</p>
      <p style="font-size: 27px;margin-bottom: 10px">为资本寻路 为新生力量赋能</p>
      <p style="font-size: 14px;margin-bottom: 0">SIG是总部设于美国的全球领先的量化交易金融公司，</p>
      <p style="font-size: 14px;margin-bottom: 0">拥有独有的创新、严谨的交易理念和技术，</p>
      <p style="font-size: 14px">是高性能、低延迟交易的全球领导者和创新者。</p>

      <div class="index_down">
        <a-button type="ghost" shape="circle-outline" size="large">
          <template v-slot:icon>
            <DownOutlined>
            </DownOutlined>
          </template>
        </a-button>
      </div>
    </div>
  </div>
</template>
<script>
import {DownOutlined} from '@ant-design/icons-vue'

export default {
  name: 'Contact_index_m',
  components: {DownOutlined,},
  setup() {
    const next_page = () => {
      document.documentElement.scrollBy({
        top: window.innerHeight * 92 / 100,
        behavior: "smooth",
      })
    }
    return {next_page}
  }

}
</script>
<style scoped>
.contact_index {
  background-image: url("../../../assets/background/contact_index.jpg");
  height: 100vh;
  background-repeat: no-repeat;
  background-position: center;
  background-size: auto 100%;
  margin: 0;
  text-align: center;
}

.contact_index_text {
  padding-top: 40vh;
}

.index_down {
  padding-top: 2vh;
}
</style>